import { Vector3 } from "three";
import {
  IInputEventHandler,
  InputEventType,
  InputMultiPointerEvent,
  InputPointerType,
  IPinchArgs,
  ISwipeArgs,
} from "../utils/input-handler/interface";
import { Viewer } from "../viewer";
import { InputHandler } from "../utils/input-handler/input-handler";

export class CoordTracker implements IInputEventHandler {
  private _viewer: Viewer;
  private _inputHandler: InputHandler;
  private _callback: (res: Vector3) => void;

  constructor(
    viewer: Viewer,
    inputHandler: InputHandler,
    callback: (res: Vector3) => void
  ) {
    this._viewer = viewer;
    this._inputHandler = inputHandler;
    this._callback = callback;
  }

  public handlePointerEvent(
    pointer: { pointerType: InputPointerType; eventType: InputEventType },
    event: PointerEvent
  ) {
    if (this._viewer.whileOperation) {
      return;
    }

    if (pointer.eventType === InputEventType.POINTER_HOVER) {
      const point = this._viewer.intersectPointCloud(event);
      const offset = this._viewer.getOffset();
      this._callback(
        point
          ? new Vector3(
              point.x - offset.x,
              point.y - offset.y,
              point.z - offset.z
            )
          : null
      );
    }
  }

  public handleMultiplePointerEvent(
    eventType: InputMultiPointerEvent,
    args: ISwipeArgs | IPinchArgs
  ): void {}
}
